<script>
    import { onMount } from "svelte";
    import { usucon } from "../store/";

    import Api from "../api";

    export let graduadoId=0;

    const api = new Api("graduado");

    let carreras = [];

    const errores = {
        display: "none",
        mensaje: "",
        mostrar(m) {
            errores.mensaje = m;
            errores.display = "block";
        },
        reset() {
            errores.display = "none";
            errores.mensaje = "";
        },
    };

    onMount(async () => { 
        cargar();
    });

    async function cargar(){
        let param = new FormData();
        param.append("accion", "graduado_carreras");
        param.append("token", $usucon.token);
        param.append("user_id", $usucon.user_id);
        const result = await api.procesar(param);
        if (result.error) {
            errores.mostrar(result.mensaje);
        } else {
            errores.reset();
            carreras = [...result.datos];
        }
    };
</script>

<div class="w3-padding">
    <table class="w3-table-all w3-hoverable w3-small">
        <thead>
            <tr>
                <th>Facultad / Carrera</th>
                <th>Tipo de grado</th>
                <th>Plan</th>
                <th>Fecha de egreso</th>
                <th>Edad de egreso</th>
            </tr>
        </thead>
        <tbody>
            {#if errores.display == "block"}
                <tr><td colspan="2" class="w3-yellow w3-text-red w3-center">{errores.mensaje}</td></tr>
            {:else}
                {#each carreras as c}
                    <tr>
                        <td>{c.nom_uni}<br>{c.nom_car}</td>
                        <td>{c.tipoDeGrado}</td>
                        <td>{c.plan}</td>
                        <td>{c.fechaEgreso}</td>
                        <td>{c.edadEgreso}</td>
                    </tr>
                {/each}
            {/if}
        </tbody>
    </table>
</div>
